import { createContext, useContext, useEffect, useState } from "react";

export const translations = {
  ar: {
    brand: { name: "CONNECTED CENTER", sub: "مركز كونكتد" },
    nav: {
      links: ["الرئيسية", "خدماتنا", "استوديو الألوان", "البروشورات", "أعمالنا", "الضمان", "تواصل معنا"],
      cta: "واتساب",
      menuLabel: "فتح القائمة",
      homeAria: "مركز كونكتد - الرئيسية",
    },
    hero: {
      kicker: "حضور مختلف. عناية بكل تفصيل.",
      title1a: "سيارتك.",
      title1b: "بتوقيع كونكتد.",
      title2a: "حماية تليق بتفاصيلها،",
      title2b: "ولون يعكس شخصيتك",
      subtitle:
        "اكتشف عالم تغليف السيارات وحماية الطلاء في مركز كونكتد بالبصرة، حيث يلتقي الاختيار المدروس بالعناية بكل تفصيل.",
      btnWorks: "استعرض أعمالنا",
      btnWhats: "تحدث معنا عبر واتساب",
      imgAlt: "رينج روفر سوداء داخل صالة عرض مركز كونكتد",
    },
    marquee: [
      "حماية الطلاء PPF",
      "تغليف وتغيير اللون",
      "ألوان AEGIS",
      "العناية بالتفاصيل",
      "ضمان مكتوب",
      "تشطيب يليق بسيارتك",
    ],
    services: {
      eyebrow: "خدماتنا",
      headingA: "التفاصيل تصنع الفرق —",
      headingB: "DETAILS DEFINE THE DIFFERENCE",
      items: [
        {
          title: "حماية الطلاء — PPF",
          category: "PAINT PROTECTION",
          description:
            "فيلم حماية شفاف يحافظ على طلاء سيارتك من الخدوش والحصى والعوامل الجوية، بلمسة غير مرئية ولمعان يدوم.",
          tag: "الأكثر طلباً",
        },
        {
          title: "تغيير اللون",
          category: "COLOR & FINISH",
          description: "عالم ألوان AEGIS: لامع، طافٍ، وألوان جريئة تُعبّر عنك.",
        },
        {
          title: "العناية بالتفاصيل",
          category: "THE FINISHING TOUCH",
          description: "تشطيب دقيق للحواف والزجاج والتفاصيل، لأن الفرق يظهر في النهاية.",
        },
        {
          title: "ضمانك المكتوب",
          category: "YOUR WARRANTY",
          description:
            "كل عملية في كونكتد موثّقة بضمان مكتوب ورمز QR خاص بسيارتك، مع إرشادات عناية وصيانة واضحة بعد التسليم.",
        },
      ],
    },
    colors: {
      eyebrow: "AEGIS / THE ART OF COLOR",
      headingA: "لون يعبّر عنك.",
      headingB: "وحضور يشبهك.",
      paragraph:
        "من الهدوء الأنيق إلى الجرأة اللافتة، اكتشف عالم ألوان AEGIS واختر الإطلالة القادمة لسيارتك — عينات بأكواد واضحة، ويُعتمد اللون من العينة الفعلية تحت الإضاءة قبل التنفيذ.",
      finishes: ["لامع", "طافٍ", "ألوان"],
      button: "اطلب مشاهدة العينات",
    },
    library: {
      eyebrow: "THE AEGIS LIBRARY",
      heading: "تصفّح. قارن. اختر بثقة.",
      paragraph: "البروشورات وكتالوجات الألوان، في مكان واحد.",
      items: [
        {
          title: "مجموعة ألوان AEGIS",
          desc: "الكتالوج الجديد بعلامة كونكتد المائية. عينات الألوان وأكواد ADJ في عرض إلكتروني.",
        },
        {
          title: "تعرّف على AEGIS",
          desc: "الحماية والتشطيبات وتفاصيل المادة في بروشور إلكتروني.",
        },
        {
          title: "مساحة أكبر للاختيار",
          desc: "استكشف مجموعة الألوان الإضافية وتفاصيل العينات.",
        },
      ],
      view: "تصفّح إلكترونياً",
      download: "تحميل PDF",
    },
    works: {
      eyebrow: "SELECTED WORK / CONNECTED CENTER",
      heading: "تفاصيل تستحق النظرة الثانية.",
      featured: [
        { title: "حضور هادئ. تفاصيل بارزة.", alt: "شيفروليه تاهو بتشطيب رمادي داخل ورشة كونكتد" },
        { title: "لون يترك انطباعًا.", alt: "مرسيدس زرقاء بلمعان واضح داخل المركز" },
        { title: "العناية تظهر في النهاية.", alt: "واجهة BMW داخل المركز وإضاءة تنعكس على الهيكل" },
      ],
      journal: "THE CONNECTED JOURNAL — صور وألوان من عالم المركز",
    },
    process: {
      eyebrow: "A CONSIDERED APPROACH",
      headingA: "قبل اللمعة،",
      headingB: "اهتمام بالتفاصيل.",
      paragraph:
        "تبدأ التجربة بفهم سيارتك وما تريده منها، ونساعدك في اختيار المادة واللون والتشطيب المناسب.",
      steps: [
        { title: "نفهم اختيارك", description: "معاينة السيارة ومناقشة اللون واللمسة المطلوبة." },
        { title: "نهتم بالتحضير", description: "تجهيز السطح والعناية بالتفاصيل قبل التطبيق." },
        { title: "نعتني بالتنفيذ", description: "تطبيق الفيلم والاهتمام بالحواف والتشطيب." },
        { title: "نوضح ما بعد التسليم", description: "شرح ضمان المادة المختارة وإرشادات العناية والصيانة." },
      ],
    },
    warranty: {
      eyebrow: "CONNECTED CENTER / YOUR WARRANTY",
      headingA: "ضمانك —",
      headingB: "رمز كونكتد بين يديك.",
      paragraph:
        "كل سيارة تخرج من مركزنا تحمل ضماناً مكتوباً على المادة والتنفيذ من AEGIS. امسح الرمز بكاميرا هاتفك للاطلاع على تفاصيل ضمانك، أو تحقق منه مباشرة عبر موقع الضمان الرسمي.",
      verify: "تحقق من ضمانك — 5aegis.com",
      save: "احفظ الرمز",
      qrCaption: "امسح الرمز أو اضغط هنا للدخول إلى بوابة الضمان 5aegis.com",
      qrAlt: "رمز QR كونكتد سنتر — ضمانك عبر 5aegis.com",
    },
    contact: {
      eyebrow: "LET'S TALK ABOUT YOUR CAR",
      headingA: "الإطلالة القادمة لسيارتك،",
      headingB: "تبدأ من هنا.",
      paragraph:
        "تواصل معنا لاختيار اللون والمادة المناسبة، ومعرفة التوفر وتفاصيل التنفيذ. أسرع طريق للرد: محادثة واتساب مباشرة.",
      whatsapp: "ابدأ المحادثة عبر واتساب",
      info: [
        { label: "العنوان", value: "طريق حمدان، البصرة، العراق" },
        { label: "أوقات العمل", value: "السبت — الخميس: 10:00 صباحاً — 10:00 مساءً · الجمعة مغلق" },
        { label: "الهاتف / واتساب", value: "+964 776 050 6057" },
        { label: "إنستغرام", value: "@connected_center_basra" },
        { label: "البريد الإلكتروني", value: "Info@5aegis.com" },
        { label: "بريد إضافي", value: "Info@eliteworld-iq.com" },
      ],
      labels: {
        name: "الاسم الكامل",
        phone: "رقم الهاتف",
        car: "نوع السيارة (اختياري)",
        service: "الخدمة المطلوبة",
        message: "رسالتك",
      },
      placeholders: {
        name: "أدخل اسمك الكريم",
        phone: "07XX XXX XXXX",
        car: "مثال: رينج روفر 2023",
        message: "أخبرنا عن سيارتك وما ترغب به...",
      },
      services: ["حماية الطلاء PPF", "تغيير اللون — ألوان AEGIS", "العناية بالتفاصيل", "استفسار عام"],
      submit: "أرسل طلبك",
      sending: "جارٍ الإرسال...",
      successToast: "وصلتنا رسالتك بنجاح، وسيتواصل معك فريق كونكتد قريباً.",
      errorToast: "تعذر إرسال الرسالة، يرجى المحاولة مرة أخرى أو التواصل عبر واتساب.",
    },
    footer: {
      brandText:
        "مركز كونكتد — البصرة، العراق. حماية طلاء PPF، تغليف وتغيير لون بألوان AEGIS، وعناية بكل تفصيل. حضور مختلف، بضمان مكتوب.",
      quickLinks: "روابط سريعة",
      links: ["خدماتنا", "استوديو الألوان", "البروشورات", "أعمالنا", "الضمان", "تواصل معنا", "بوابة الضمان — 5aegis.com"],
      newsletterTitle: "النشرة البريدية",
      newsletterText: "اشترك ليصلك جديد الألوان والأعمال والعروض قبل الجميع.",
      placeholder: "بريدك الإلكتروني",
      subscribeAria: "اشترك في النشرة البريدية",
      subscribedToast: "تم اشتراكك في نشرتنا، ترقب جديد الألوان والعروض.",
      alreadyToast: "هذا البريد مشترك لدينا مسبقاً، أهلاً بك مجدداً.",
      errorToast: "تعذر الاشتراك، يرجى التحقق من البريد والمحاولة مجدداً.",
      copyright: "© 2026 مركز كونكتد · البصرة، العراق — حضور مختلف. عناية بكل تفصيل.",
    },
  },
  en: {
    brand: { name: "CONNECTED CENTER", sub: "مركز كونكتد" },
    nav: {
      links: ["Home", "Services", "Color Studio", "Brochures", "Our Work", "Warranty", "Contact"],
      cta: "WhatsApp",
      menuLabel: "Open menu",
      homeAria: "Connected Center - Home",
    },
    hero: {
      kicker: "A different presence. Care for every detail.",
      title1a: "Your car.",
      title1b: "Signed by Connected.",
      title2a: "Protection worthy of every detail,",
      title2b: "and a color that reflects you",
      subtitle:
        "Discover paint protection and car wrapping at Connected Center in Basra, where considered choices meet care for every detail.",
      btnWorks: "Explore our work",
      btnWhats: "Chat on WhatsApp",
      imgAlt: "Black Range Rover inside the Connected Center showroom",
    },
    marquee: [
      "PPF Paint Protection",
      "Wrapping & Color Change",
      "AEGIS Colors",
      "Detailing & Finish",
      "Written Warranty",
      "A Finish Worthy of Your Car",
    ],
    services: {
      eyebrow: "OUR SERVICES",
      headingA: "Details make the difference —",
      headingB: "DETAILS DEFINE THE DIFFERENCE",
      items: [
        {
          title: "Paint Protection — PPF",
          category: "PAINT PROTECTION",
          description:
            "A clear film that shields your paint from scratches, gravel and the elements — invisible to the eye, with lasting gloss.",
          tag: "Most requested",
        },
        {
          title: "Color Change",
          category: "COLOR & FINISH",
          description: "The AEGIS color world: gloss, matte, and bold colors that express you.",
        },
        {
          title: "Detailing & Finish",
          category: "THE FINISHING TOUCH",
          description: "Precise finishing for edges, glass and details — the difference shows at the end.",
        },
        {
          title: "Your Written Warranty",
          category: "YOUR WARRANTY",
          description:
            "Every job at Connected is documented with a written warranty and a QR code for your car, plus clear aftercare guidance.",
        },
      ],
    },
    colors: {
      eyebrow: "AEGIS / THE ART OF COLOR",
      headingA: "A color that expresses you.",
      headingB: "A presence that feels like you.",
      paragraph:
        "From elegant calm to striking boldness, explore the AEGIS color world and choose your car's next look — samples with clear codes, and the color is approved from the physical sample under lighting before installation.",
      finishes: ["Gloss", "Matte", "Colors"],
      button: "Request to view samples",
    },
    library: {
      eyebrow: "THE AEGIS LIBRARY",
      heading: "Browse. Compare. Choose with confidence.",
      paragraph: "Brochures and color catalogs, all in one place.",
      items: [
        {
          title: "AEGIS Color Collection",
          desc: "The new watermarked Connected catalog. Color samples and ADJ codes in an interactive viewer.",
        },
        {
          title: "Meet AEGIS",
          desc: "Protection, finishes and material details in a digital brochure.",
        },
        {
          title: "More possibilities",
          desc: "Explore the additional color range and sample details.",
        },
      ],
      view: "Open viewer",
      download: "Download PDF",
    },
    works: {
      eyebrow: "SELECTED WORK / CONNECTED CENTER",
      heading: "Details that deserve a second look.",
      featured: [
        { title: "Quiet presence. Sharp details.", alt: "Chevrolet Tahoe with a grey finish inside the Connected workshop" },
        { title: "A color that leaves an impression.", alt: "Blue Mercedes with a deep gloss inside the center" },
        { title: "The care shows in the finish.", alt: "BMW front end with light reflecting off the bodywork" },
      ],
      journal: "THE CONNECTED JOURNAL — frames and colors from the center's world",
    },
    process: {
      eyebrow: "A CONSIDERED APPROACH",
      headingA: "Before the shine,",
      headingB: "care for the details.",
      paragraph:
        "The experience starts by understanding your car and what you want from it — and we help you choose the right material, color and finish.",
      steps: [
        { title: "We understand your choice", description: "Vehicle inspection and a discussion of the color and desired finish." },
        { title: "We prepare with care", description: "Surface preparation and detail care before application." },
        { title: "We execute with precision", description: "Film application with attention to edges and finishing." },
        { title: "We explain what comes after", description: "A walkthrough of your material warranty and aftercare guidance." },
      ],
    },
    warranty: {
      eyebrow: "CONNECTED CENTER / YOUR WARRANTY",
      headingA: "Your warranty —",
      headingB: "Connected's code in your hands.",
      paragraph:
        "Every car leaving our center carries a written AEGIS warranty on material and installation. Scan the code with your phone camera to view your warranty details, or verify it directly on the official warranty portal.",
      verify: "Verify your warranty — 5aegis.com",
      save: "Save the code",
      qrCaption: "Scan the code or tap here to open the 5aegis.com warranty portal",
      qrAlt: "Connected Center warranty QR code — via 5aegis.com",
    },
    contact: {
      eyebrow: "LET'S TALK ABOUT YOUR CAR",
      headingA: "Your car's next look,",
      headingB: "starts here.",
      paragraph:
        "Talk to us to choose the right color and material, check availability and installation details. The fastest way to reach us: a direct WhatsApp chat.",
      whatsapp: "Start a WhatsApp chat",
      info: [
        { label: "Address", value: "Hamdan Road, Basra, Iraq" },
        { label: "Working hours", value: "Sat — Thu: 10:00 AM — 10:00 PM · Friday closed" },
        { label: "Phone / WhatsApp", value: "+964 776 050 6057" },
        { label: "Instagram", value: "@connected_center_basra" },
        { label: "Email", value: "Info@5aegis.com" },
        { label: "Additional email", value: "Info@eliteworld-iq.com" },
      ],
      labels: {
        name: "Full name",
        phone: "Phone number",
        car: "Car model (optional)",
        service: "Requested service",
        message: "Your message",
      },
      placeholders: {
        name: "Enter your name",
        phone: "07XX XXX XXXX",
        car: "e.g. Range Rover 2023",
        message: "Tell us about your car and what you'd like...",
      },
      services: ["PPF Paint Protection", "Color change — AEGIS colors", "Detailing & finish", "General enquiry"],
      submit: "Send your request",
      sending: "Sending...",
      successToast: "Your message reached us — the Connected team will contact you soon.",
      errorToast: "Could not send your message. Please try again or reach us on WhatsApp.",
    },
    footer: {
      brandText:
        "Connected Center — Basra, Iraq. PPF paint protection, AEGIS color wrapping, and care for every detail. A different presence, with a written warranty.",
      quickLinks: "Quick links",
      links: ["Services", "Color Studio", "Brochures", "Our Work", "Warranty", "Contact", "Warranty portal — 5aegis.com"],
      newsletterTitle: "Newsletter",
      newsletterText: "Subscribe to get new colors, works and offers before everyone else.",
      placeholder: "Your email address",
      subscribeAria: "Subscribe to the newsletter",
      subscribedToast: "You're subscribed — watch for new colors and offers.",
      alreadyToast: "This email is already subscribed — welcome back.",
      errorToast: "Subscription failed — please check the email and try again.",
      copyright: "© 2026 Connected Center · Basra, Iraq — A different presence. Care for every detail.",
    },
  },
};

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("ar");

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  const value = {
    lang,
    dir: lang === "ar" ? "rtl" : "ltr",
    t: translations[lang],
    toggle: () => setLang((l) => (l === "ar" ? "en" : "ar")),
  };

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useLang() {
  return useContext(LangContext);
}
